import { useEffect, useRef } from 'react';
import { useWatch } from 'react-hook-form';

import { useUnitRecalculationStore } from 'store/useUnitRecalculationStore';

import { GLOBAL_UNIT_NAME } from 'components/BusinessToolForm/Sections/Global/form';

export const UnitRecalculationTracker = () => {
  const unit = useWatch({ name: GLOBAL_UNIT_NAME });
  const previousUnit = useRef(unit);

  useEffect(() => {
    if (previousUnit.current && previousUnit.current !== unit) {
      useUnitRecalculationStore.getState().begin();
    }

    previousUnit.current = unit;
  }, [unit]);

  return null;
};
